import { truncateString } from "@/utils/truncateString";
import styles from "./Card.module.css";
import { ClothingItem } from "@/types/product";
import { useImageLoading } from "@/hooks/useImageLoading";

import EmptyProduct from "../../assets/emptyProduct.svg";

interface ListCardProps {
  item: ClothingItem;
  onClick?: () => void;
}

export function ListCard({ item, onClick }: ListCardProps) {
  const productImage = item.product_images[0];
  const { imageURI, handleImageLoad } = useImageLoading(productImage?.image);

  const hasImages = item && item?.product_images?.length > 0;

  return (
    <div className={styles.listCard} onClick={onClick}>
      <div className={styles.listImage}>
        <img
          className={styles.gridImageContent}
          src={hasImages ? (imageURI as string) : EmptyProduct}
          onLoad={handleImageLoad}
        />
      </div>
      <div className={styles.listDetails}>
        <div className={styles.listBrand}>{item.brand.name}</div>
        <div className={styles.listName}>{truncateString(item.name, 65)}</div>
        <div className={styles.listMeta}>
          <span>{item.category_name}</span>
          <span>·</span>
          <span>{formatDateToYYYYMMDD(new Date(item?.purchased_at as string))}</span>
          {/* {showMember && memberName && (
            <>
              <span>·</span>
              <span>{memberName}</span>
            </>
          )} */}
        </div>
      </div>
      <div className={styles.listPrice}>${formatPrice(Number(item.price_paid))}</div>
    </div>
  );
}

function formatPrice(price: number): string {
  return price.toLocaleString("en-US", {
    minimumFractionDigits: price % 1 ? 2 : 0
  });
}

function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
